import APIService from './APIService';

export default {
  getViewsAtivas(bdgdVersaoId) {
    return APIService.apiCall().get(`/diagnosticos-pre-etapa-17/get-views-ativas/${bdgdVersaoId}`);
  },
  getDadosViewDiagnostico(bdgdVersaoId, viewDiagnostico) {
    return APIService.apiCall().get(`/diagnosticos-pre-etapa-17/get-dados-view-diagnostico/${bdgdVersaoId}/${viewDiagnostico}`);
  },
  atualizaDadosViewDiagnostico(bdgdVersaoId, viewDiagnostico) {
    return APIService.apiCall().get(
      `/diagnosticos-pre-etapa-17/atualiza-dados-view-diagnostico/${bdgdVersaoId}/${viewDiagnostico}`
    );
  },
  baixarResultadoDadosViewDiagnostico(bdgdVersaoId, viewDiagnostico, config = {}) {
    return APIService.apiCall().get(
      `/diagnosticos-pre-etapa-17/baixar-resultado-dados-view-diagnostico/${bdgdVersaoId}/${viewDiagnostico}`,
      { responseType: 'blob', ...config }
    );
  },
  baixarDetalhamentoAtributosGerais(bdgdVersaoId, id, tabela, config = {}) {
    return APIService.apiCall().get(
      `/diagnosticos-pre-etapa-17/baixar-detalhamento-atributos-gerais/${bdgdVersaoId}/${id}/${tabela}`,
      {
        responseType: 'blob',
        ...config
      }
    );
  },
  baixarDetalhamentoTrafoDiferente(bdgdVersaoId, tabela, config = {}) {
    return APIService.apiCall().get(`/diagnosticos-pre-etapa-17/baixar-detalhamento-trafo-diferente/${bdgdVersaoId}/${tabela}`, {
      responseType: 'blob',
      ...config
    });
  },
  baixarDetalhamentoConectividade(bdgdVersaoId, tabela, config = {}) {
    return APIService.apiCall().get(`/diagnosticos-pre-etapa-17/baixar-detalhamento-conectividade/${bdgdVersaoId}/${tabela}`, {
      responseType: 'blob',
      ...config
    });
  }
};
